import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import * as React from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    pagePublishDate: getCurrentPage(state).fields.publishDate,
    pageAuthor: getCurrentPage(state).fields.author,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface BlogDetailPublishInfoWidgetStyles {
    publishInfo?: TypographyProps;
}

export const blogDetailPublishInfoWidgetStyles: BlogDetailPublishInfoWidgetStyles = {
    publishInfo: {
        variant: "h6",
        forwardAs: "span",
    },
};

const styles = blogDetailPublishInfoWidgetStyles;

const BlogDetailPublishInfoWidget = ({ pagePublishDate, pageAuthor }: Props) => {
    if (!pagePublishDate && !pageAuthor) {
        return null;
    }

    const dateOptions: Intl.DateTimeFormatOptions = { year: "numeric", month: "short", day: "numeric" };
    const dateTimeFormat = new Intl.DateTimeFormat("en-US", dateOptions);
    return (
        <>
            <Typography {...styles.publishInfo}>
                {pagePublishDate && translate("Posted on")}{" "}
                {pagePublishDate && dateTimeFormat.format(new Date(pagePublishDate))} {pageAuthor && `by ${pageAuthor}`}{" "}
            </Typography>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(BlogDetailPublishInfoWidget) as any,
    definition: {
        displayName: "Detail Publish Info",
        group: "Verndale Box - Blog" as any,
        icon: "heading",
        allowedContexts: ["BlogDetailPage"] as any,
    },
};

export default widgetModule;
